module.exports = __webpack_public_path__ + "img/soil-sensor-suboptimal.7fabc448.svg";